export default "__VITE_ASSET__BkSGl_OG__"